import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface loadingFilterSchedule {
  isLoading: boolean
  setLoadingState(state: boolean): void
}

export const useLoadingFilterScheduleStore = create<loadingFilterSchedule>()(
  devtools(
    (set) => ({
      isLoading: false,
      setLoadingState(state = false) {
        set({ isLoading: state }, false, 'setLoadingState')
      }
    }),
    { name: 'useLoadingFilterScheduleStore' }
  )
)
